<div *ngIf="bookingSurvey.surveyForm" class="survey-form">
  <form [formGroup]="bookingSurvey.surveyForm" id="varden-survey-form">
    <div class="survey-form__header full-width">Dina uppgifter</div>
    <div
      *ngFor="
        let field of this.bookingData.providerMeta$ | async;
        trackBy: trackByMethod
      "
      [ngClass]="getCssClassNameByFieldType(field.type)"
    >
      <div [ngClass]="field.type | lowercase" [ngSwitch]="field.type">
        <mat-form-field
          *ngSwitchCase="fieldTypeEnum.DATEPICKER"
          appearance="outline"
          class="full-width"
        >
          <div class="field-fixed-label">{{ field.label }}</div>
          <input
            [matDatepicker]="picker"
            [ngClass]="'test-booking-' + field.key.toLowerCase()"
            [placeholder]="field.placeholder"
            formControlName="{{ field.key }}"
            matInput
          >
          <mat-datepicker-toggle
            [for]="picker"
            matSuffix
          ></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          <mat-error
            *ngIf="
              bookingSurvey.surveyForm.controls[field.key].hasError('required')
            "
          >
            {{ field.label }} måste anges
          </mat-error>
        </mat-form-field>

        <mat-form-field
          *ngSwitchCase="fieldTypeEnum.TEXT"
          appearance="outline"
          class="full-width"
          floatLabel="always"
        >
          <div class="field-fixed-label">{{ field.label }}</div>
          <input
            (blur)="onBlur(field.key)"
            [ngClass]="'test-booking-' + field.key.toLowerCase()"
            [placeholder]="field.placeholder"
            formControlName="{{ field.key }}"
            matInput
          >
          <mat-error
            *ngIf="
              bookingSurvey.surveyForm.controls[field.key].hasError('required')
            "
          >
            {{ field.label }} måste anges
          </mat-error>
          <mat-error
            *ngIf="
              bookingSurvey.surveyForm.controls[field.key].hasError('pattern')
            "
          >
            Vänligen skriv rätt format.
          </mat-error>
          <mat-error
            *ngIf="
              bookingSurvey.surveyForm.controls[field.key].hasError('minlength')
            "
          >
            Vänligen skriv minst {{ field.validationRules.minLength }} tecken
          </mat-error>
          <mat-error
            *ngIf="
              bookingSurvey.surveyForm.controls[field.key].hasError('maxlength')
            "
          >
            Vänligen skriv högst {{ field.validationRules.maxLength }} tecken
          </mat-error>
        </mat-form-field>

        <mat-form-field
          *ngSwitchCase="fieldTypeEnum.PERSONAL_NUMBER"
          appearance="outline"
          class="half-width personal-number-field"
          floatLabel="always"
        >
          <div class="field-fixed-label">{{ field.label }}</div>
          <input
            [ngClass]="'test-booking-' + field.key.toLowerCase()"
            [placeholder]="field.placeholder"
            formControlName="{{ field.key }}"
            matInput
          >
          <mat-error
            *ngIf="
              bookingSurvey.surveyForm.controls[field.key].hasError('required')
            "
          >
            {{ field.label }} måste anges
          </mat-error>
          <mat-error
            *ngIf="
              bookingSurvey.surveyForm.controls[field.key].hasError('pattern')
            "
          >
            Vänligen skriv rätt format: 19701212-xxxx.
          </mat-error>
          <mat-error
            *ngIf="
              bookingSurvey.surveyForm.controls[field.key].hasError('minlength')
            "
          >
            Vänligen skriv minst {{ field.validationRules.minLength }} tecken
          </mat-error>
          <mat-error
            *ngIf="
              bookingSurvey.surveyForm.controls[field.key].hasError('maxlength')
            "
          >
            Vänligen skriv högst {{ field.validationRules.maxLength }} tecken
          </mat-error>
        </mat-form-field>

        <div
          *ngSwitchCase="fieldTypeEnum.PERSONAL_NUMBER"
          class="personal-number-info"
        >
          <app-ui-icon
            color="rgba(132, 146, 165, 1)"
            name="info"
            size="sm"
          ></app-ui-icon>
          <div class="content">
            Ditt personnummer behövs för att registrera dig hos vårdgivaren. Det
            delas aldrig med någon annan.
          </div>
        </div>

        <mat-form-field
          *ngSwitchCase="fieldTypeEnum.TEXTAREA"
          appearance="outline"
          class="full-width textarea-field"
          floatLabel="always"
        >
          <div class="field-fixed-label">{{ field.label }}</div>
          <textarea
            [ngClass]="'test-booking-' + field.key.toLowerCase()"
            [placeholder]="field.placeholder"
            formControlName="{{ field.key }}"
            matInput
            rows="3"
          ></textarea>
          <mat-error
            *ngIf="
              bookingSurvey.surveyForm.controls[field.key].hasError('required')
            "
            class="max-w-[75%] sm:max-w-[85%] md:max-w-[90%]"
          >
            {{ field.label }} måste anges
          </mat-error>
          <mat-error
            *ngIf="
              bookingSurvey.surveyForm.controls[field.key].hasError('minlength')
            "
            class="max-w-[75%] sm:max-w-[85%] md:max-w-[90%]"
          >
            Vänligen skriv minst {{ field.validationRules.minLength }} tecken
          </mat-error>
          <mat-error
            *ngIf="
              bookingSurvey.surveyForm.controls[field.key].hasError('maxlength')
            "
            class="max-w-[75%] sm:max-w-[85%] md:max-w-[90%]"
          >
            Vänligen skriv högst {{ field.validationRules.maxLength }} tecken
          </mat-error>

          <div *ngIf="field.validationRules && field.validationRules.maxLength > 0"
               [ngClass]="{'text-error': bookingSurvey.surveyForm.controls[field.key].invalid && (bookingSurvey.surveyForm.controls[field.key].dirty || bookingSurvey.surveyForm.controls[field.key].touched), 'text-gray-6': bookingSurvey.surveyForm.controls[field.key].valid}"
               class="text-xs text-right w-fit absolute right-[-.75rem] bottom-[-1.25rem]">
            {{ bookingSurvey.surveyForm.controls[field.key].value?.length }} / {{ field.validationRules.maxLength }}
          </div>
        </mat-form-field>

        <div
          *ngSwitchCase="fieldTypeEnum.BOOLEAN"
          class="survey-form__checkbox"
        >
          <mat-checkbox
            [ngClass]="'test-booking- my-4' + field.key.toLowerCase()"
            color="primary"
            formControlName="{{ field.key }}"
          >
            {{ field.label }}
          </mat-checkbox>
          <div class="survey-form__checkbox__description">
            {{ field.description }}
          </div>
          <mat-error
            *ngIf="
              bookingSurvey.surveyForm.controls[field.key].touched &&
              bookingSurvey.surveyForm.controls[field.key].hasError('required')
            "
          >
            Obligatoriskt fält
          </mat-error>
        </div>

        <app-vd-multiselect
          *ngSwitchCase="fieldTypeEnum.MULTISELECT"
          [field]="field"
          [form]="bookingSurvey.surveyForm"
        >
        </app-vd-multiselect>

        <app-vd-radio
          *ngSwitchCase="fieldTypeEnum.RADIO"
          [field]="field"
          [form]="bookingSurvey.surveyForm"
        >
        </app-vd-radio>

        <div *ngSwitchCase="fieldTypeEnum.PHONE_NUMBER" class="flex justify-start gap-2">

          <mat-form-field
            appearance="outline"
            class="grow-0 basis-20"
          >
            <div class="field-fixed-label">{{ field.label }}</div>
            <mat-select
              formControlName="pnCountryCode"
            >
              <mat-option value="+46">+46</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field
            appearance="outline"
            class="grow"
            floatLabel="always"
          >

            <input
              (keydown)="preventNonNumeric($event)"
              (paste)="preventNonNumericPaste($event)"
              (wheel)="handleScroll($event)"
              [ngClass]="'test-booking-' + field.key.toLowerCase()"
              [placeholder]="field.placeholder"
              formControlName="{{ field.key }}"
              inputmode="numeric"
              matInput
              pattern="[0-9]*"
              type="number"
            >

            <mat-error
              *ngIf="
              bookingSurvey.surveyForm.controls[field.key].hasError('required')
            "
            >
              {{ field.label }} måste anges
            </mat-error>
            <mat-error
              *ngIf="
              bookingSurvey.surveyForm.controls[field.key].hasError('pattern')
            "
            >
              Vänligen kontrollera telefonnumret.
            </mat-error>
            <mat-error
              *ngIf="
              bookingSurvey.surveyForm.controls[field.key].hasError('minlength')
            "
            >
              Vänligen skriv minst {{ field.validationRules.minLength }} tecken
            </mat-error>
            <mat-error
              *ngIf="
              bookingSurvey.surveyForm.controls[field.key].hasError('maxlength')
            "
            >
              Vänligen skriv högst {{ field.validationRules.maxLength }} tecken
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="full-width policy-section">
      <mat-checkbox
        [formControlName]="surveyAdditionalFieldsEnum.GDPR"
        [ngClass]="'test-booking-gdpr my-4'"
        color="primary"
      >
        Jag samtycker till att Vården.se behandlar uppgifter om min hälsa enligt
        GDPR artikel 9 (dock aldrig journaluppgifter) för att genomföra
        bokningen. För mer information om hur Vården.se behandlar dina
        personuppgifter se
        <a [routerLink]="['/', 'info', 'integritetspolicy']" target="_blank"
        >Integritetspolicy</a
        >. *

        <mat-error
          *ngIf="
            bookingSurvey.surveyForm.controls[surveyAdditionalFieldsEnum.GDPR]
              .touched &&
            bookingSurvey.surveyForm.controls[
              surveyAdditionalFieldsEnum.GDPR
            ].hasError('required')
          "
        >
          Obligatoriskt fält
        </mat-error>
      </mat-checkbox>
    </div>
    <div class="full-width text-sm">
      * Obligatoriskt fält
    </div>
  </form>
</div>
